'use client';

import type { RegionSelectorWidgetData } from '@weberus/shared-types';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { IcNearmeFill } from '@yanolja-rnd/nol-icons';
import { type FC } from 'react';
import { clientLogStandardized } from '@weberus/client-tracker';
import { getSubHomeTargetType } from '@/app/(pages)/sub-home/[category]/constants';
import { RecentSelected } from './recent-selected';
import { RecentSelectButton } from './recent-select-button';

export interface RegionSelectorProps {
  data: RegionSelectorWidgetData;
  pageNameLog: HomeLogPageNameValue;
}

export const TARGET_TO_AROUND_LINK: { [key in string]: string } = {
  DOMESTIC_MOTEL: '/around/keyword-motel?sourcePage=Motel',
  DOMESTIC_HOTEL: '/around/keyword-hotel?sourcePage=Hotel',
  DOMESTIC_PENSION: '/around/keyword-pension?sourcePage=Pension',
  DOMESTIC_GUESTHOUSE: '/around/keyword-guestHouse?sourcePage=GuestHouse',
};

/**
 *  국내숙소 지역 선택 위젯
 *
 *  @see {@link https://www.figma.com/design/zlHuiOHmYv1ghVDbTHUSvW/%5BGUIDE%5D-%EC%9C%84%EC%A0%AF%2F%EC%98%A4%EB%8D%94%EB%A7%81?node-id=3235-21410&m=dev}
 */
export const RegionSelector: FC<RegionSelectorProps> = ({ data, pageNameLog }) => {
  const { regionDiscovery, regionRecentSelected } = data;
  const targetType = getSubHomeTargetType(pageNameLog);

  const recentSelectedButtonTitle =
    regionDiscovery.items.find((item) => item.type === 'BUTTON_REGION')?.title || '지역 선택';

  return (
    <div className="my-4 flex w-full justify-center pc:my-40 pc:max-w-pc-size">
      <div className="mx-16 my-4 flex w-full flex-col items-center rounded-12 border border-fill-neutral-weak3 text-text-neutral-main pc:max-w-[1064px]">
        <p className="mb-16 mt-24 typography-subtitle-18-bold pc:mb-24 pc:mt-32 pc:typography-headline-24-bold">
          {regionDiscovery.header.title}
        </p>
        <div className="mb-20 flex w-full justify-center gap-4 px-20 pc:mb-32">
          <RecentSelectButton title={recentSelectedButtonTitle} pageNameLog={pageNameLog} targetType={targetType} />
          <a
            className="flex size-46 flex-col items-center justify-center gap-2 rounded-8 border border-fill-neutral-main shadow-2 pc:size-60"
            href={TARGET_TO_AROUND_LINK[targetType]}
            onClick={() =>
              clientLogStandardized('click', pageNameLog, {
                object: 'regionSelectBtn',
                objectContainer: 'regionSelection',
                selectType: '내주변',
              })
            }>
            <IcNearmeFill className="size-20 pc:size-22" />
            <span className="typography-label-10-regular pc:typography-body-13-regular">
              {regionDiscovery.items.find((item) => item.type === 'BUTTON_AROUND')?.title}
            </span>
          </a>
        </div>
        <RecentSelected regionRecentSelected={regionRecentSelected} pageNameLog={pageNameLog} target={targetType} />
      </div>
    </div>
  );
};
